















































import {
  EventSceneManagementEventImageDTO,
  EventSceneManagementEventSceneService as eventScene,
} from "@/common/api";
import QErrors from "@/common/qErrors.vue";
import {
  default as QUploadSingleImage,
  default as qUploadSingleImageFile,
} from "@/components/common/qUploadSingleImage.vue";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "EventRemoteUploadImageComponent",
  components: {
    QUploadSingleImage,
    QErrors,
  },
})
export default class EventRemoteUploadImageComponent extends Vue {
  @Prop({ required: true })
  public readonly eventId: number;
  @Prop({ required: true })
  public readonly eventSceneId: number;

  public isLoading = false;
  public errors = {};

  @Emit("uploadedEventImage")
  public uploadedEventImage(eventImage: EventSceneManagementEventImageDTO) {
    return eventImage;
  }

  @Emit("deletedEventImage")
  public deletedEventImage(eventImageId: number) {
    return eventImageId;
  }

  public uploadStatus(flag: boolean): void {
    this.isLoading = flag;
  }

  public async uploadFile(imagesTableEntity) {
    /**
        q-upload-single-image コンポーネントにて画像を選択し、
        選択された画像は aws へアップロードされ、その後、images テーブルに登録されます。
        その後、コールバックにて images テーブルの id や name が file(uploadFile(file)) に格納されます。
     */
    const imageId = imagesTableEntity.id; // imagesテーブルのID
    const eventImage = await this.uploadEventImage(imageId);
    if (!eventImage) {
      return;
    }
    (this.$refs.uploadSingleImage as qUploadSingleImageFile).reset();
    this.uploadedEventImage(eventImage);
  }

  public async uploadEventImage(imageId: number) {
    try {
      this.isLoading = true;
      const result = await eventScene.adminEventSceneUploadEventImage({
        eventId: this.eventId,
        eventSceneId: this.eventSceneId,
        imageId,
      });
      if (result.status === "error") {
        throw new Error(result.message);
      }
      return result.data.eventImage;
    } catch (error) {
      this.errors = {
        ...this.errors,
        ...{
          imageId: {
            0:
              (error as Error).message ||
              this.$t("common.message.errors.image"),
          },
        },
      };
      return null;
    } finally {
      this.isLoading = false;
    }
  }

  public open() {
    (this.$refs.uploadSingleImage as qUploadSingleImageFile).open();
  }

  @Emit("uploadImageCancel")
  public handleCancel() {}

  public async deleteEventImage(image) {
    console.log("deleteEventImage", image);
    try {
      this.isLoading = true;
      const result = await eventScene.adminEventSceneDeleteEventImage({
        eventId: this.eventId,
        eventImageId: image.eventImageId,
        imageId: image.id,
      });
      if (result.status === "error") {
        throw new Error(result.message);
      }
      this.deletedEventImage(image.eventImageId);
    } catch (error) {
      this.errors = {
        ...this.errors,
        ...{
          imageId: {
            0:
              (error as Error).message ||
              this.$t("common.message.errors.image"),
          },
        },
      };
    } finally {
      this.isLoading = false;
    }
  }
}
